import { put, call, takeLatest } from 'redux-saga/effects';

import { productionError } from '../../lib/production';
import {
  fetchLine,
  fetchSets,
  fetchDevice,
  fetchCharger,
  fetchDevices,
  fetchQuality,
  fetchBenches,
  fetchChargers,
} from '../apis/production';
import {
  getSetsAction,
  getLineAction,
  getSetsSuccess,
  getSetsFailure,
  getLineSuccess,
  getLineFailure,
  getDeviceAction,
  getDeviceSuccess,
  getDeviceFailure,
  getChargerAction,
  getDevicesAction,
  getQualityAction,
  getBenchesAction,
  getChargerSuccess,
  getChargerFailure,
  getDevicesSuccess,
  getDevicesFailure,
  getQualitySuccess,
  getQualityFailure,
  getBenchesSuccess,
  getBenchesFailure,
  getChargersAction,
  getChargersSuccess,
  getChargersFailure,
} from '../slices/production';

const read = (fetch, success, failure, fallback) =>
  function* handleRead() {
    try {
      const response = yield call(fetch);
      yield put(success(response));
    } catch (error) {
      yield put(failure(productionError(error, fallback)));
    }
  };

// takeLatest cancels the previous page's request, so a late answer never lands.
const readList = (fetch, success, failure, fallback) =>
  function* handleList(action) {
    try {
      const response = yield call(fetch, action.payload);
      yield put(
        success({
          items: response?.data || [],
          total: response?.total_records || 0,
          page: response?.page || action.payload?.page || 1,
          pageSize: response?.limit || 50,
        })
      );
    } catch (error) {
      yield put(failure(productionError(error, fallback)));
    }
  };

const readDetail = (fetch, success, failure, fallback) =>
  function* handleDetail(action) {
    const ficr = action.payload;
    if (!ficr) return;
    try {
      const data = yield call(fetch, ficr);
      yield put(success({ ficr, data }));
    } catch (error) {
      yield put(failure({ ficr, error: productionError(error, fallback) }));
    }
  };

export default function* productionSaga() {
  yield takeLatest(
    getLineAction.type,
    read(fetchLine, getLineSuccess, getLineFailure, 'Could not load the line')
  );
  yield takeLatest(
    getDevicesAction.type,
    readList(fetchDevices, getDevicesSuccess, getDevicesFailure, 'Could not load the devices')
  );
  yield takeLatest(
    getDeviceAction.type,
    readDetail(fetchDevice, getDeviceSuccess, getDeviceFailure, 'Could not load this device')
  );
  yield takeLatest(
    getChargersAction.type,
    readList(fetchChargers, getChargersSuccess, getChargersFailure, 'Could not load the chargers')
  );
  yield takeLatest(
    getChargerAction.type,
    readDetail(fetchCharger, getChargerSuccess, getChargerFailure, 'Could not load this charger')
  );
  yield takeLatest(
    getSetsAction.type,
    readList(fetchSets, getSetsSuccess, getSetsFailure, 'Could not load the bound sets')
  );
  yield takeLatest(
    getQualityAction.type,
    read(fetchQuality, getQualitySuccess, getQualityFailure, 'Could not load the quality figures')
  );
  yield takeLatest(
    getBenchesAction.type,
    read(fetchBenches, getBenchesSuccess, getBenchesFailure, 'Could not load the benches')
  );
}
